export const LAST_UPDATED_DATE_FORMAT = 'dd-MMM-yyyy';
export const MAX_TOPOLOGY_REMOTE_ACCESS_COUNT = 120;
export const FORM_SECTION_CLASSES = 'col-6 col-2xl-4';
